import { getCookie, setCookie, deleteCookie } from '@/tools/utils';

interface authTokens {
  token: string;
  refresh_token: string;
  expired_at: string;
}

const load = (authlocalStorageKey: string) => {
  if (getCookie('session_token') && getCookie('refresh_token')) {
    return {
      refresh_token: getCookie('refresh_token'),
      token: getCookie('session_token'),
    };
  }
  return null;
};

const save = (value: authTokens, authlocalStorageKey: string) => {
  setCookie('session_token', value.token, { expires: 86400 });
  setCookie('refresh_token', value.refresh_token);
};

const remove = (authlocalStorageKey: string) => {
  deleteCookie('session_token');
  deleteCookie('refresh_token');
};

const createSession = () => ({ load, save, remove });
export default createSession;



// WEBPACK FOOTER //
// ./src/tools/session.ts